import { render, staticRenderFns } from "./ContentFilter.vue?vue&type=template&id=31a22ff5"
import script from "./ContentFilter.vue?vue&type=script&lang=ts"
export * from "./ContentFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports